export default __webpack_public_path__ + "static/media/RappiAliadosSilentPrinting.7d1d9882.bat";